export const getBaseUrl = (pathname) => {
  const lastPathIndex = pathname.lastIndexOf('/')
  return pathname.slice(0, lastPathIndex)
}

export const redirectToGym = () => {
  window.location = `${process.env.REACT_APP_SITE_URL}/find-a-gym`
}
